import { Outlet, useNavigate } from "react-router";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { LanguageSwitcher } from "@/components/language-switcher";

export function TrackingLayout() {
  const navigate = useNavigate();
  const { t } = useTranslation("tracking");
  const [inputTrackingNumber, setInputTrackingNumber] = useState("");

  const handleTrack = () => {
    if (inputTrackingNumber.trim()) {
      void navigate(`/tracking/${inputTrackingNumber.trim()}`);
      setInputTrackingNumber("");
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <header className="border-b relative z-50 bg-background shadow-sm">
        <div className="container mx-auto max-w-6xl py-4 px-4 sm:px-0">
          <div className="flex flex-col sm:flex-row sm:justify-between gap-4">
            <div className="flex items-center justify-between sm:justify-start gap-4">
              <h1 className="text-xl sm:text-2xl font-semibold">
                <span className="text-primary">{t("tooez")}</span>{" "}
                <span className="text-foreground">{t("tracking")}</span>
              </h1>
              <div className="sm:hidden">
                <LanguageSwitcher />
              </div>
            </div>
            {/* Tracking form - desktop only */}
            <div className="hidden sm:flex flex-row gap-3 items-center">
              <input
                type="text"
                value={inputTrackingNumber}
                onChange={(e) => setInputTrackingNumber(e.target.value)}
                placeholder={t("enterTrackingNumber")}
                className="w-64 px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary"
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleTrack();
                  }
                }}
              />
              <button
                onClick={handleTrack}
                className="px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors"
              >
                {t("common:track")}
              </button>
              <LanguageSwitcher />
            </div>
          </div>
        </div>
      </header>
      <main className="pb-12">
        <Outlet />
      </main>
    </div>
  );
}
